import React, { useId, useState } from 'react';
import { HelpCircle } from 'lucide-react';

const MetricHelp = ({ label, text }) => {
  const tooltipId = useId();
  const [open, setOpen] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0, above: false });

  const show = (event) => {
    const rect = event.currentTarget.getBoundingClientRect();
    const width = 256;
    const estimatedHeight = 132;
    const left = Math.max(8, Math.min(rect.left, window.innerWidth - width - 8));
    const above = rect.bottom + 8 + estimatedHeight > window.innerHeight && rect.top > estimatedHeight;

    setPosition({
      top: above ? rect.top - 8 : rect.bottom + 8,
      left,
      above,
    });
    setOpen(true);
  };

  const hide = () => {
    setOpen(false);
  };

  return (
    <>
      <button
        type="button"
        className="inline-flex shrink-0 rounded-full text-gray-400 hover:text-gray-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
        aria-label={`Erklärung zu ${label}`}
        aria-describedby={open ? tooltipId : undefined}
        onMouseEnter={show}
        onMouseLeave={hide}
        onFocus={show}
        onBlur={hide}
      >
        <HelpCircle className="w-3.5 h-3.5" />
      </button>
      {open && (
        <span
          id={tooltipId}
          role="tooltip"
          style={{
            top: position.top,
            left: position.left,
            transform: position.above ? 'translateY(-100%)' : undefined,
          }}
          className="fixed z-50 w-64 rounded-lg bg-gray-900 px-3 py-2 text-left text-xs font-normal normal-case tracking-normal text-white shadow-lg"
        >
          {text.split('\n\n').map((paragraph) => (
            <span key={paragraph} className="mt-2 block first:mt-0">
              {paragraph}
            </span>
          ))}
        </span>
      )}
    </>
  );
};

export default MetricHelp;
